import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { DiscountCodeInputComponent } from './components/discount-code-input/discount-code-input.component';
import { DiscountsCheckboxSelectorComponent } from './components/discounts-checkbox-selector/discounts-checkbox-selector.component';
import { DiscountsSelectorComponent } from './components/discounts-selector/discounts-selector.component';

import { DiscountService } from './services/discount.service';
import { DiscountTotalService } from './services/discount-total.service';

@NgModule({

    declarations: [

        DiscountCodeInputComponent,
        DiscountsCheckboxSelectorComponent,
        DiscountsSelectorComponent

    ],

    imports: [

        CommonModule,
        SharedModule,
        TemplateModule

    ],

    exports: [

        DiscountsSelectorComponent

    ],

    providers: [

        DiscountService,
        DiscountTotalService

    ]

})
export class DiscountsModule { }
